"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import GeneralFormatter from "../../formatters/general";
import ShipmentApprovalApi from "../../api/acertus_shipment_approval";
import TopApi from "../../api/api";
const ShipmentStatus = {
  Pending: (_) => ({ tag: "Pending" }),
  Approved: ({ date }) => ({ tag: "Approved", date }),
  Rejected: ({ choice, reason }) => ({ tag: "Rejected", choice, reason }),
  handle: (status, { pending, approved, rejected }) => {
    switch (status.tag) {
      case "Pending":
        return pending();
      case "Approved":
        return approved({ date: status.date });
      case "Rejected":
        return rejected({ choice: status.choice, reason: status.reason });
      default:
        return console.error("Unhandled ShipmentStatus tag", status.tag);
    }
  }
};
const WebData = {
  Loading: (_) => ({ tag: "Loading" }),
  Success: ({ value }) => ({ tag: "Success", value }),
  Failure: ({ reason }) => ({ tag: "Failure", reason }),
  handle: (data, { loading, success, failure }) => {
    switch (data.tag) {
      case "Loading":
        return loading();
      case "Success":
        return success({ value: data.value });
      case "Failure":
        return failure({ reason: data.reason });
      default:
        return console.error("Unhandled WebData tag", data.tag);
    }
  },
  updateValue: (data, updater) => {
    return WebData.handle(data, {
      loading: (_) => data,
      failure: (_) => data,
      success: ({ value }) => WebData.Success({ value: updater(value) })
    });
  }
};
const Api = /* @__PURE__ */ ((_) => {
  const fromJson = (cannedReasons2) => (json) => {
    const reasonFromJson = ({ reason }) => {
      if (cannedReasons2.indexOf(reason) === -1) {
        return { choice: "Other", reason };
      } else {
        return { choice: reason, reason: "" };
      }
    };
    return {
      id: json.id,
      shipmentId: json.shipment_id,
      vin: json.vin,
      geofence_flags: json.geofence_flags,
      status: json.status === "pending" ? ShipmentStatus.Pending() : json.status === "approved" ? ShipmentStatus.Approved(json.status_details) : json.status === "rejected" ? ShipmentStatus.Rejected(reasonFromJson(json.status_details)) : console.error(`Unrecognized status: ${json.status}`)
    };
  };
  const toJson = (cannedReasons2, shipment) => {
    const baseFields = {
      id: shipment.id,
      shipment_id: shipment.shipmentId,
      vin: shipment.vin
    };
    const reasonToJson = ({ choice, reason }) => {
      if (cannedReasons2.indexOf(choice) === -1) {
        return { reason };
      } else {
        return { reason: choice };
      }
    };
    return ShipmentStatus.handle(shipment.status, {
      pending: (_2) => __spreadProps(__spreadValues({}, baseFields), {
        status: "pending"
      }),
      approved: ({ date }) => __spreadProps(__spreadValues({}, baseFields), {
        status: "approved",
        status_details: { date }
      }),
      rejected: ({ choice, reason }) => __spreadProps(__spreadValues({}, baseFields), {
        status: "rejected",
        status_details: reasonToJson({ choice, reason })
      })
    });
  };
  return {
    get: ({ invoice, cannedReasons: cannedReasons2 }) => ShipmentApprovalApi.get({ invoice_id: invoice.id }).then(
      (shipments) => shipments.map(fromJson(cannedReasons2))
    ),
    put: ({ invoice, shipment, cannedReasons: cannedReasons2 }) => ShipmentApprovalApi.put({
      invoice_id: invoice.id,
      shipment: toJson(cannedReasons2, shipment)
    }).then(fromJson(cannedReasons2))
  };
})();
function cannedReasons() {
  const customExceptionReasons = TopApi.Account.currentSettings().custom_invoice_exception_messages || [];
  return customExceptionReasons.sort();
}
function initializeChoices({ shipments }) {
  return shipments.reduce((choices, shipment) => {
    if (shipment.status && shipment.status.tag === "Rejected") {
      choices[shipment.id] = shipment.status.choice || cannedReasons()[0] || "Other";
    } else {
      choices[shipment.id] = "";
    }
    return choices;
  }, {});
}
function initializeReasons({ shipments }) {
  return shipments.reduce((reasons, shipment) => {
    if (shipment.status && shipment.status.tag === "Rejected") {
      reasons[shipment.id] = shipment.status.reason || "";
    } else {
      reasons[shipment.id] = "";
    }
    return reasons;
  }, {});
}
function byShipmentId(a, b) {
  if (!a || !b) return 0;
  if (a.shipment_id < b.shipment_id) {
    return -1;
  } else if (a.shipment_id > b.shipment_id) {
    return 1;
  } else {
    return 0;
  }
}
function renderGeofenceFlagIcon(shipment, flag) {
  const icon = shipment.geofence_flags[flag] ? "fi-check" : "fi-x";
  const color = shipment.geofence_flags[flag] ? "green" : "red";
  return /* @__PURE__ */ React.createElement("i", { className: `shipment-approval__flags__icon ${icon} ${color}` });
}
function renderGeofenceFlags(shipment) {
  return /* @__PURE__ */ React.createElement("ul", { className: "shipment-approval__flags__list" }, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("span", { className: "shipment-approval__flags__list__title" }, "Pickup geofence certified", /* @__PURE__ */ React.createElement("span", { className: "colon" }, ": ")), /* @__PURE__ */ React.createElement("span", { className: "shipment-approval__flags__list__icon" }, renderGeofenceFlagIcon(shipment, "pickup"))), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("span", { className: "shipment-approval__flags__list__title" }, "Delivery geofence certified", /* @__PURE__ */ React.createElement("span", { className: "colon" }, ": ")), /* @__PURE__ */ React.createElement("span", { className: "shipment-approval__flags__list__icon" }, renderGeofenceFlagIcon(shipment, "delivery"))), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("span", { className: "shipment-approval__flags__list__title" }, "Allow Geofence as POD", /* @__PURE__ */ React.createElement("span", { className: "colon" }, ": ")), /* @__PURE__ */ React.createElement("span", { className: "shipment-approval__flags__list__icon" }, renderGeofenceFlagIcon(shipment, "use_as_pod"))));
}
function renderApprovedShipmentOptions(shipment, { date }) {
  return {
    icon: "fi-check",
    color: "green",
    caption: `Approved on ${GeneralFormatter.date(date)}`,
    body: null
  };
}
function maybeUpdateShipmentStatus(props, shipment) {
  if (shipment.id == props.shipmentUpdate.id) {
    if (props.shipmentUpdate.approved) {
      shipment.status.tag = "Approved";
      shipment.status.date = props.shipmentUpdate.date;
    } else {
      shipment.status.tag = "Pending";
    }
  }
}
const AcertusShipmentApproval = React.createClass({
  // eslint-disable-line no-restricted-syntax -- Legacy React.createClass - to be migrated
  getInitialState() {
    return {
      shipments: WebData.Loading(),
      choices: {},
      reasons: {}
    };
  },
  refreshShipments() {
    const invoice = this.props.carrierInvoice;
    Api.get({ invoice, cannedReasons: cannedReasons() }).then((shipments) => WebData.Success({ value: shipments })).catch((reason) => WebData.Failure({ reason })).then(
      (data) => this.setState({
        shipments: data,
        choices: WebData.handle(data, {
          loading: (_) => ({}),
          success: ({ value }) => initializeChoices({ shipments: value }),
          failure: (_) => ({})
        }),
        reasons: WebData.handle(data, {
          loading: (_) => ({}),
          success: ({ value }) => initializeReasons({ shipments: value }),
          failure: (_) => ({})
        })
      })
    );
  },
  componentDidMount() {
    this.props.addShipmentAssignmentListener(
      "shipment-approvals",
      this.refreshShipments
    );
    this.refreshShipments();
  },
  render() {
    return /* @__PURE__ */ React.createElement("div", { "data-component": "AcertusShipmentApproval", className: "load-detail__acertus-shipment-approval-section" }, /* @__PURE__ */ React.createElement("h3", { className: "load-detail__section-header" }, "Shipment Approval"), WebData.handle(this.state.shipments, {
      loading: (_) => /* @__PURE__ */ React.createElement("div", null, "Loading shipments..."),
      success: ({ value }) => this.renderShipments({ shipments: value }),
      failure: ({ reason }) => /* @__PURE__ */ React.createElement("div", null, "Failure: ", reason)
    }));
  },
  renderShipments({ shipments }) {
    return /* @__PURE__ */ React.createElement("div", { className: "shipment-approvals" }, [...shipments].sort(byShipmentId).map((shipment) => this.renderShipment(shipment)));
  },
  renderShipment(shipment) {
    maybeUpdateShipmentStatus(this.props, shipment);
    const options = ShipmentStatus.handle(shipment.status, {
      pending: (_) => this.props.hasAssignedPod(shipment) ? this.renderReadyToApproveShipmentOptions(shipment) : this.renderMissingPodShipmentOptions(shipment),
      approved: (details) => renderApprovedShipmentOptions(shipment, details),
      rejected: (details) => this.renderRejectedShipmentOptions(shipment, details)
    });
    const settings = TopApi.Account.currentSettings() || {};
    const geofence_flags = settings.feature_display_shipment_status_geofence_flags ? renderGeofenceFlags(shipment) : null;
    const title = `${shipment.shipmentId} - ${shipment.vin}`;
    return /* @__PURE__ */ React.createElement("div", { className: "shipment-approval", key: shipment.id }, /* @__PURE__ */ React.createElement("div", { className: "shipment-approval__header" }, /* @__PURE__ */ React.createElement(
      "i",
      {
        className: `shipment-approval__icon ${options.icon} ${options.color}`
      }
    ), /* @__PURE__ */ React.createElement("strong", null, title)), /* @__PURE__ */ React.createElement("div", { className: "shipment-approval__body" }, /* @__PURE__ */ React.createElement("div", { className: "shipment-approval__flags" }, geofence_flags), /* @__PURE__ */ React.createElement("span", { className: "shipment-approval__caption" }, options.caption), options.body));
  },
  renderMissingPodShipmentOptions(shipment) {
    return {
      icon: "fi-circle",
      color: "blue",
      caption: `POD is required for approval`,
      body: /* @__PURE__ */ React.createElement("div", { className: "shipment-approval__controls" }, /* @__PURE__ */ React.createElement("button", { className: "button--link bold unclickable" }, "Approve"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "button--link danger",
          onClick: (_) => this.clickedBeginReject(shipment)
        },
        "Reject"
      ))
    };
  },
  renderReadyToApproveShipmentOptions(shipment) {
    return {
      icon: "fi-circle",
      color: "green",
      caption: `Ready to approve`,
      body: /* @__PURE__ */ React.createElement("div", { className: "shipment-approval__controls" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "button--link bold",
          onClick: (_) => this.clickedApprove(shipment)
        },
        "Approve"
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "button--link danger",
          onClick: (_) => this.clickedBeginReject(shipment)
        },
        "Reject"
      ))
    };
  },
  renderRejectedShipmentOptions(shipment, { choice, reason }) {
    const handleReasonInput = (event) => {
      const reasons = this.state.reasons;
      reasons[shipment.id] = event.target.value;
      this.setState({ reasons });
    };
    const handleChoiceSelect = (event) => {
      const choices = this.state.choices;
      const reasons = this.state.reasons;
      choices[shipment.id] = event.target.value;
      reasons[shipment.id] = "";
      this.setState({ choices, reasons });
    };
    const hasLocalChanges = reason !== this.state.reasons[shipment.id] || choice !== this.state.choices[shipment.id];
    const noOptionSelected = this.state.choices[shipment.id] === null;
    const primaryButton = noOptionSelected ? /* @__PURE__ */ React.createElement("button", { className: "button--link bold unclickable" }, "Select a reason") : hasLocalChanges ? /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "button--link bold",
        onClick: (_) => this.clickedSaveRejection(shipment)
      },
      "Save reason"
    ) : /* @__PURE__ */ React.createElement("button", { className: "button--link bold unclickable" }, "Reason saved!");
    const selectionOptions = cannedReasons().concat(["Other"]);
    const renderReasonChoices = /* @__PURE__ */ React.createElement(
      "select",
      {
        className: "shipment-approval__reason-choice",
        defaultValue: "null",
        value: this.state.choices[shipment.id],
        onChange: handleChoiceSelect
      },
      /* @__PURE__ */ React.createElement("option", { value: "null", disabled: true }, "Reason"),
      selectionOptions.map((choice_, i) => /* @__PURE__ */ React.createElement("option", { key: i, value: choice_ }, choice_))
    );
    const choseOtherReason = this.state.choices[shipment.id] === "Other";
    const renderTextarea = /* @__PURE__ */ React.createElement(
      "textarea",
      {
        className: "shipment-approval__reason",
        placeholder: "Reason",
        value: this.state.reasons[shipment.id],
        onChange: handleReasonInput
      }
    );
    return {
      icon: "fi-x",
      color: "red",
      caption: `Shipment rejected`,
      body: /* @__PURE__ */ React.createElement("div", null, renderReasonChoices, choseOtherReason ? renderTextarea : "", /* @__PURE__ */ React.createElement("div", { className: "shipment-approval__controls" }, primaryButton, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "button--link",
          onClick: (_) => this.clickedUnassign(shipment)
        },
        "Clear"
      )))
    };
  },
  clickedApprove(shipment) {
    const date = (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
    const invoice = this.props.carrierInvoice;
    return Api.put({
      invoice,
      shipment: __spreadProps(__spreadValues({}, shipment), {
        status: ShipmentStatus.Approved({ date })
      }),
      cannedReasons: cannedReasons()
    }).then((shipment2) => this.updateShipment(shipment2)).catch((reason) => console.error("clickedApprove", reason)).then((_) => this.props.onUpdate());
  },
  clickedUnassign(shipment) {
    const invoice = this.props.carrierInvoice;
    return Api.put({
      invoice,
      shipment: __spreadProps(__spreadValues({}, shipment), {
        status: ShipmentStatus.Pending()
      }),
      cannedReasons: cannedReasons()
    }).then((shipment2) => this.updateShipment(shipment2)).catch((reason) => console.error("clickedUnassign", reason)).then((_) => this.props.onUpdate());
  },
  clickedBeginReject(shipment) {
    const choices = this.state.choices;
    const reasons = this.state.reasons;
    choices[shipment.id] = null;
    reasons[shipment.id] = "";
    this.setState({ choices, reasons });
    this.updateShipment(__spreadProps(__spreadValues({}, shipment), {
      status: ShipmentStatus.Rejected({
        choice: null,
        reason: ""
      })
    }));
  },
  updateShipment(updatedShipment) {
    this.setState({
      shipments: WebData.updateValue(
        this.state.shipments,
        (shipments) => shipments.map(
          (shipment) => updatedShipment.id === shipment.id ? updatedShipment : shipment
        )
      )
    });
  },
  clickedSaveRejection(shipment) {
    const choiceFallback = cannedReasons()[0] || "Other";
    const invoice = this.props.carrierInvoice;
    return Api.put({
      invoice,
      shipment: __spreadProps(__spreadValues({}, shipment), {
        status: ShipmentStatus.Rejected({
          choice: this.state.choices[shipment.id] || choiceFallback,
          reason: this.state.reasons[shipment.id] || ""
        })
      }),
      cannedReasons: cannedReasons()
    }).then((shipment2) => this.updateShipment(shipment2)).catch((reason) => console.error("clickedBeginReject", reason)).then((_) => this.props.onUpdate());
  }
});
export default AcertusShipmentApproval;
